<template>
	<div class="app app-ti_green">


		<router-view />
		<Foot />

	</div>
</template>

<script>
	import Header from './libs/Header';
	import Foot from './libs/Foot';
	export default {
		name: 'Main',
		data() {
			return {
				baseURL: '',
			};
		},
		components: {
			Header,
			Foot,
		},
		created() {
			let that = this;

			that.baseURL = sessionStorage.getItem('baseURL') || '';
		},
		updated() {
			let that = this;
		},
		mounted() {
			let that = this;
			// 获取页面链接的authorization参数 存到token 自动登录
			// const queryParams = new URLSearchParams(window.location.search);
			// const authorization = queryParams.get('authorization'); // 替换'paramName'为你的参数名
			const authorization = that.$route.query.authorization; // 替换'paramName'为你的参数名
			// console.log("authorization", authorization);
			if (authorization) {
				console.log("Main.vue首页有authorization", authorization);
				that.$parent.showTost(1, "登录成功");
				sessionStorage.setItem('token', authorization);
				that.$store.commit('changToken');
				that.$parent.getUserInfo();
				that.$parent.openDaoTime();
				// that.$parent.goNav('/');
			}

		},
		methods: {
			outLogin() {
				this.$parent.outLogin();
			},
			openDaoTime() {
				this.openDaoTime();
			},
			closeDaoTime() {
				this.$parent.closeDaoTime();
			},
			openGamePage(name, type, code) {
				this.$parent.openGamePage(name, type, code);
			},

			goNav(url) {
				this.$parent.goNav(url);
			},

			getUserInfo() {
				this.$parent.getUserInfo();
			},
			getUserInfoShowLoding() {
				this.$parent.getUserInfoShowLoding();
			},
			doCopy(msg) {
				this.$parent.doCopy(msg);
			},
			showLoading() {
				this.$parent.showLoading();
			},
			hideLoading() {
				this.$parent.hideLoading();
			},
			openKefu() {
				this.$parent.openKefu();
			},
			getAgentLoginUrl() {
				this.$parent.getAgentLoginUrl();
			},
			showTost(type, title) {
				this.$parent.showTost(type, title);
			},
			getBalance() {
				this.$parent.getBalance();
			},
		},
		beforeDestroy() {
			let that = this;
			if (that.daoTime) {
				clearInterval(that.daoTime);
			}
			that.daoTime = null;
		},
		// watch: {
		//   //监听路由地址的改变
		//   $route: {
		//     immediate: true,
		//     handler() {
		//       let that = this;
		//       that.path = this.$route.path;
		//     },
		//   },
		// },
	};
</script>

<style lang="scss" scoped>
	// @import '../../static/css/announcement_modal.css';
</style>


// WEBPACK FOOTER //
// src/components/Main.vue